<template lang="pug">
  v-app.timeline
    bar-and-nav(v-model="navDrawer" :links="links" mini)
      scrollactive(:offset='viewHeight / 2' :scroll-offset='76' highlight-first-item)
        nav-list(:items="items")
    v-main.main.w-100
      v-timeline(:reverse="isLandscape" :dense="isPortrait").mx-4
        v-timeline-item(v-for="item in items" :key="item.slug" :id="item.slug")
          template(v-slot:opposite)
            embed-frame(:url="item.embed" :width="embedWidth" :y-offset="37").mb-16
          div(:style="isLandscape ? landscapeTimelineItemStyle : portraitTimelineItemStyle").h-100.d-flex.flex-column.justify-center
            v-card.my-auto(outlined).mb-16
              v-card-title
                h2.text-center.black--text.mb-0(style="width:100%") {{item.title}}
              v-card-text
                embed-frame(v-if="isPortrait && item.embed" :url="item.embed" :width="embedWidth" :y-offset="37").mb-4
                .subtitle-2.text-left.desc(:style="descStyle")
                  vue-markdown {{item.content}}
      v-footer(color="#005cb8")
        p.ma-auto.white--text.body-2 Copyright © {{new Date().getFullYear()}} Arlington County Virginia
</template>

<script>
import BarAndNav from '@/components/BarAndNav.vue'
import EmbedFrame from '@/components/EmbedFrame.vue'
import NavList from '@/components/NavList.vue'
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    BarAndNav,
    EmbedFrame,
    NavList,
    VueMarkdown
  },
  props: {
    items: Array,
    links: Array
  },
  data: () => ({
    navDrawer: undefined
  }),
  computed: {
    isPortrait () {
      return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width
    },
    isLandscape () {
      return !this.isPortrait
    },
    viewHeight () {
      return this.$vuetify.breakpoint.height - 56
    },
    landscapeTimelineItemStyle () {
      let minHeight = (this.$vuetify.breakpoint.width - 56 - 24 - 96) / (2 * 1.7)
      return `min-height:${minHeight}px`
    },
    portraitTimelineItemStyle () {
      return ``
    },
    embedWidth () {
      const NAV_WIDTH = 56
      const CONTENT_MARGIN_WIDTH = 16
      const TIMELINE_DIVIDER_WIDTH = 96
      let contentWidth = this.$vuetify.breakpoint.mdAndDown ? this.$vuetify.breakpoint.width : this.$vuetify.breakpoint.width - NAV_WIDTH
      if(this.isLandscape)
        return ((contentWidth - TIMELINE_DIVIDER_WIDTH) / 2 ) - CONTENT_MARGIN_WIDTH
      else
        return contentWidth - 4 * CONTENT_MARGIN_WIDTH - TIMELINE_DIVIDER_WIDTH
    },
    embedHeight () {
      const EMBED_BAR_HEIGHT = 36
      return (9 / 16) * this.embedWidth + EMBED_BAR_HEIGHT
    },
    descStyle () {
      const TITLE = 56
      const PADDING = 16
      return `height:${this.embedHeight - TITLE - PADDING}px;overflow-y:scroll`
    }
  }
}
</script>

<style lang="stylus">
.timeline
  .main
    position: absolute

</style>